import { useSubmitGroupLifeProposalAnalysis } from '@/features/proposals/hooks/group-life';
import { getErrorStatusCode } from '@/shared/utils';
import { useCallback } from 'react';

export type ApprovePmeProposalOutcome =
  | { kind: 'approved' }
  | {
      kind: 'failed';
      /** HTTP da falha, quando o serviço carimbou. */
      statusCode?: number;
      message: string;
    };

/**
 * Aprovação da proposta PME em análise.
 *
 * É só a aprovação: grava "Proposta Aceita" (7) e devolve a proposta ao
 * corretor, que confere o Resumo e dispara a assinatura pelo Confirmar. A
 * assinatura NÃO sai daqui — o mapping da carta comercial é montado na tela do
 * corretor, e o subscritor nem sempre tem a corretora na sessão.
 *
 * Falha mantém o subscritor na tela de análise, com a proposta ainda em
 * análise: o `outcome` carrega o motivo para quem chamou exibir.
 */
export function useApprovePmeProposalAnalysis(policyId: string) {
  const submitAnalysis = useSubmitGroupLifeProposalAnalysis();

  const approve = useCallback(async (): Promise<ApprovePmeProposalOutcome> => {
    try {
      await submitAnalysis.mutateAsync({ policyId });
      return { kind: 'approved' };
    } catch (error) {
      return {
        kind: 'failed',
        statusCode: getErrorStatusCode(error),
        message:
          error instanceof Error
            ? error.message
            : 'Não foi possível aprovar a proposta. Tente novamente.',
      };
    }
  }, [submitAnalysis, policyId]);

  return { approve, isApproving: submitAnalysis.isPending };
}
